<iframe *ngIf="boleto" [src]="boleto | safe"></iframe>
<h4 *ngIf="!boleto">Nenhum boleto encontrado</h4>